import { message } from 'antd';
import { push } from 'react-router-redux';

import { setUseSavedPlanFormFields } from '../plan/actions';

const MODULE_NAME = 'QUOTE';

export const goBackToForm = () => dispatch => {
  dispatch(setUseSavedPlanFormFields(true));
  dispatch(push('/provider/new-plan'));
};

export const GET_QUOTE_PENDING = `${MODULE_NAME}/GET_QUOTE/PENDING`;
export const GET_QUOTE_SUCCESS = `${MODULE_NAME}/GET_QUOTE/SUCCESS`;
export const GET_QUOTE_FAIL = `${MODULE_NAME}/GET_QUOTE/FAIL`;
export const getQuote = id => async dispatch => {
  dispatch({ type: GET_QUOTE_PENDING });

  try {
    const result = await fetch(`/provider/new-plan/${id}`);

    return dispatch({ type: GET_QUOTE_SUCCESS, payload: result });
  } catch (e) {
    return dispatch({ type: GET_QUOTE_FAIL, payload: 'Plan not found' });
  }
};

export const EMAIL_QUOTE_PENDING = `${MODULE_NAME}/EMAIL_QUOTE/PENDING`;
export const EMAIL_QUOTE_SUCCESS = `${MODULE_NAME}/EMAIL_QUOTE/SUCCESS`;
export const EMAIL_QUOTE_FAIL = `${MODULE_NAME}/EMAIL_QUOTE/FAIL`;
export const emailQuote = id => async dispatch => {
  dispatch({ type: EMAIL_QUOTE_PENDING });

  try {
    await fetch(`/provider/api/plans/${id}/email-quote`, {
      method: 'POST',
    });

    message.success('Quote was emailed.');

    return dispatch({ type: EMAIL_QUOTE_SUCCESS });
  } catch (e) {
    message.error('Something went wrong');
    return dispatch({ type: EMAIL_QUOTE_FAIL, payload: e });
  }
};
